import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../common/page_component/index.js';
import { useScanQrModal } from '../../context/ScanQrModalContext.js';
import { useTranslation } from 'react-i18next';


/** Legacy route — opens the scan QR modal and returns to previous page. */
const ScanQrUpdateStatus = () => {
  const navigate = useNavigate();
  const { openScanQrModal } = useScanQrModal();

  useEffect(() => {
    openScanQrModal();
    navigate(-1);
  }, [openScanQrModal, navigate]);

  return (
    <DashboardLayout>
      <div className="py-12 text-center text-sm text-gray-500">Opening scan QR...</div>
    </DashboardLayout>
  );
};

export default ScanQrUpdateStatus;
